//$('#lang-switcher').selectize();  
// Language
// $('.halo-auth-sidebar .title').text('');
// Footer NewsLatter

// <span class="optionlang1"></span>
// <span class="optionlang2"></span>

function langugeENG() {
  $('.footer-block__newsletter .field__input').attr('placeholder', 'Enter Your Email Address');
  $('.product-form__submit').text('Add to cart');
  $('.header__search .search-modal__form .search__input').attr('placeholder', 'Search');
  $('.haloCalculatorShipping .message').text('Free shipping for all orders over $800.00!');
  $('.create-account .breadcrumb span:nth-child(3)').text('Create Account');
  $('#customer_email').attr('placeholder', 'Email');
  $('#customer_password').attr('placeholder', 'Password');
  $('.button-login').val('Log in');

  $('.breadcrumb span.account').text('Account');
  $('.submitText').val('Submit');
  $('.createAnAccount').val('Create An Account');
  $('.signInBtn').val('Sign in');
  $('#get-rates-submit').val('Calculate Shipping');
  $('#cart-coupon-code').attr('placeholder', 'Enter Coupon Code');
  
}

// 


function langugeFR() {
  $('.footer-block__newsletter .field__input').attr("placeholder", "Entrez votre adresse email");
  $('.product-form__submit').text('Ajouter au panier');
  $('.header__search .search-modal__form .search__input').attr('placeholder', 'Recherche');
  $('.haloCalculatorShipping .message').text('Livraison gratuite pour toute commande supérieure à $800.00!');
  $('.create-account .breadcrumb span:nth-child(3)').text('Créer Un Compte');
  $('#customer_email').attr('placeholder', 'Courriel');
  $('#customer_password').attr('placeholder', 'Mot De Passe');
  $('.button-login').val('Se connecter');

  $('.breadcrumb span.account').text('Compte');
  $('.submitText').val('Envoyer');
  $('.createAnAccount').val('Créer un compte');
  $('.signInBtn').val('Se Connecter');
  $('#get-rates-submit').val('Calculant');
  $('#cart-coupon-code').attr('placeholder', 'Entrer le code promotionnel');
  
  
}



$(function () {
    $('#lang-switcher').change(function() {
        if( Cookies ) {
            Cookies.set('langOption', $(this).val());
        }
        $('.option' + $(this).val()).show().siblings().hide();
    });
    var lang = Cookies && Cookies.get('langOption') || 'lang1';
    $('#lang-switcher').val(lang).trigger('change');
    $('#lang-switcher option[value='+lang+']').attr('selected', 'selected');
    $('body').addClass(lang);
    console.log(lang);
  
   if ($('body').hasClass("lang2")) {
      $('.langOption').html('<img src="https://bionutrition.com/cdn/shop/t/3/assets/i-lang-2.png" /><span>FR</span>');
       langugeFR();
   } else {
      $('.langOption').html('<img src="https://bionutrition.com/cdn/shop/t/3/assets/i-lang-1.png" /><span>ENG</span>');
      langugeENG();
   }
});

$('.header__icon--cart').click(function() {
   $('.haloCalculatorShipping .message').hide();
    if ($('body').hasClass("lang2")) {
       setTimeout(function () {
         langugeFR();
         $('.haloCalculatorShipping .message').show();
       }, 3000);
    } else {

    }
});

$('.header__icon--account').click(function() {
    if ($('body').hasClass("lang2")) {
       setTimeout(function () {
         langugeFR();
       }, 3000);
    } else {

    }
});





$('.langOption').click(function() {
  $('.langOptionUl').slideToggle();
  $('.lang-block').toggleClass('active');
});
$('.langSelectOverlay').click(function() {
  $('.langOptionUl').slideUp();
  $('.lang-block').removeClass('active');
});

$('.langOptionENG').click(function() {
  var btnHtmls = $(this).html();
  $('.langOption').html(btnHtmls);
  $('#lang-switcher').val('lang1').trigger('change');
  $('.langOptionUl').slideUp();
  $('.lang-block').removeClass('active');
  $('body').removeClass('lang2');
  $('body').addClass('lang1');
  langugeENG();
  
});
$('.langOptionFR').click(function() {
  var btnHtmls = $(this).html();
  $('.langOption').html(btnHtmls);
  $('#lang-switcher').val('lang2').trigger('change');
  $('.langOptionUl').slideUp();
  $('.lang-block').removeClass('active');
  $('body').removeClass('lang1');
  $('body').addClass('lang2');
  langugeFR();
});